import React from "react";

const AnimationContainer = ({countryIds}) => {
  return (
    <div className="idp_bg_wrapper">
      <div className="heading_blk">
        <h1>Study Abroad? <span>We Can Help!</span></h1>
        <p>Total no. of student going to study abroad.</p>
      </div>
      <div className="animation_area">
        <img src={require("../../assets/images/world_map.png")} alt="" />
        <div className={`australia_animation flight_animation ${countryIds?.includes('7')? 'isActive':''}`}>
          <span className="australia_student student_tooltip">
            Australia<br/>
            1,00,009
          </span>
        </div>

        <div className={`canada_animation flight_animation ${countryIds?.includes('4')? 'isActive':''}`}>
          <span className="canada_student student_tooltip">
            Canada<br/>
            1,83,310
          </span>
        </div>

        <div className={`usa_animation flight_animation ${countryIds?.includes('3')? 'isActive':''}`}>
          <span className="usa_student student_tooltip">
            USA<br/>
            4,65,791
          </span>
        </div>

        <div className={`uk_animation flight_animation ${countryIds?.includes('20')? 'isActive':''}`}>
          <span className="uk_student student_tooltip">
            UK<br/>
            55,465
          </span>
        </div>
        
        <div className={`ireland_animation flight_animation ${countryIds?.includes('8')? 'isActive':''}`}>
          <span className="ireland_student student_tooltip">
            Ireland<br/>
            5,000
          </span>
        </div>
      </div>
      <div className="idp_data_source">Data Source: Ministry of External Affairs of India for Year 2022</div>
    </div> 
  );
};

export default AnimationContainer;
